<template>
  <div class="order_finish">
    <div class="h5-wechat-result" v-if="h5WechatPayMiddle">
      <div class="name">请确认支付是否已完成</div>
      <div class="has-finish-btn" @click="queryPayInfoWX('finish')">已完成</div>
      <div class="repay-btn"  @click="queryPayInfoWX('repay')">遇到问题，重新支付</div>
    </div>
    <div v-else>
      <div class="page-status-1" v-if="pageStatus === 1">
        <div class="pay_result">
          <div class="pay_pic" v-if="returnMas.status==2">
            <img src="@/assets/images/payed_pic.png">
            <p>付款成功</p>
          </div>
        </div>
        <div class="color_line"></div>
        <div class="mass_tip" v-show="returnMas">
          <div class="gradient_line"></div>
          <div class="mass_box">
            <h3>{{returnMas.insuranceName}}</h3>
            <dl>
              <dt>被保险人：</dt>
              <dd>
                {{returnMas.insurantName}}
              </dd>
            </dl>
            <dl>
              <dt>订单金额：</dt>
              <dd>
                {{returnMas.price}}元
              </dd>
            </dl>
            <dl>
              <dt>保障期限：</dt>
              <dd>
                {{returnMas.insuredDuration}}
              </dd>
            </dl>
          </div>
           <a class="download_banner" v-show="banner1 && returnMas.status==2" :href="banner1.activityUrl">
              <img :src="banner1.image" alt="">
            </a>
        </div>
       
        <a class="ad_banner" v-show="banner2 && returnMas.status==2" :href="banner2.activityUrl">
          <img :src="banner2.image">
        </a>
        <a class="download_btn" v-if="returnMas.status==1" @click="download">
          下载APP，管理保费、更可享在线极速理赔
        </a>
      </div>
      <div class="page-status-2" v-if="pageStatus === 2">
        <div class="icon"><img src="@/assets/images/icon-finish.png"></div>
        <div class="name">完成</div>
        <div class="desc">下载平安健康app，管理保单</div>
        <div class="desc">更可享受在线极速理赔！</div>
        <div class="download-btn" @click="download">查收保单</div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// 根api地址，通过环境变量的配置获取
const API_PATH = process.env.VUE_APP_API_URL;
// 业务api地址
const API_UPDATE_PAYMENTSTATUS = `${API_PATH}/mapi/updatePaymentStatus.json`;
const API_QUERY_PAY_STATUS = `${API_PATH}/mapi/insurance/insuranceRenew/baseAPI/queryPayInfoWX.json`;
const API_GET_WECHAT_PAY_INFO = `${API_PATH}/mapi/insurance/insuranceRenew/baseAPI/getSignAndPayInfoWX.json`;
import base from '../mixins/base';
export default {
  name: 'OrderFinish',
  mixins: [base],
  data() {
    return {
      name: '订单完成',
      returnMas:'',
      banner1:'',
      banner2:'',
      count:0,
      pageStatus: 0,
      h5WechatPayMiddle: false,
    }
  },
  components:{

  },
  computed: {
    
  },
  methods: {
    download(){
       window.location.replace('https://m.health.pingan.com/app/download/download.html')
    },
    async queryPayInfoWX(type) {
      let query = this.$route.query;
      let params = {
        userId: this.$cookie.get('p-userId') || query.us,
        accessToken: this.$cookie.get('p-accessToken') || query.ac,
        orderNo: query.orderNo,
      };
      this.showLoading();
      const response = await axios.post(API_QUERY_PAY_STATUS, params);
      this.hideLoading();
      if (response.code === 1) {
        let data = response.data;
        if (data === '0') { // 未支付
          if (type === 'finish') {
            this.showToast('暂未查询到支付结果，请稍后重试')
          }else if(type === 'repay') {
            // 拉起h5微信支付
            let orderNo = query.orderNo;
            let userId = this.$cookie.get('p-userId') || query.us;
            let accessToken = this.$cookie.get('p-accessToken') || (query.ac && decodeURIComponent(query.ac));
            let totalMoney = this.$cookie.get('p-totalMoney') || query.tmy;
            let insId = this.$cookie.get('p-insId') || query.ins;
            let pageId = this.$cookie.get('p-pageId') || query.pid;
            this.h5WechatPay(orderNo, totalMoney, userId, accessToken, insId, pageId);
          } else if(type === 'init') {
            this.h5WechatPayMiddle = true;
          }
        } else if(data === '1') { // 已支付
          if (type === 'finish') {
            this.payResult();
          } else if(type === 'repay') {
            this.showToast('您已经完成支付，无需重新支付！');
          } else if(type === 'init') {
            this.payResult();
          }
        } else if(data === '2'){ // 支付中
          if (type === 'init') {
            this.h5WechatPayMiddle = true;
          } else {
            this.showToast('正在支付中，请稍后重试！');
          }
        }
      } else {
        this.showToast(response.msg);
      }
    },
    // H5支付，非微信内浏览器
    async h5WechatPay(orderNo, totalMoney, userId, accessToken, insId, pageId) {
      let params = {
        userId: userId,
        accessToken: accessToken,
        orderNo: orderNo,
        totalMoney: totalMoney,
        tradeType: 2,
        prepaySceneCode: '1',
      };
      this.showLoading();
      // 请求微信签约接口
      const response = await axios.post(API_GET_WECHAT_PAY_INFO, params);
      this.hideLoading();
      if (response.code === 1) {
        let data = response.data;
        let mwebUrl = data.mwebUrl;
        this.$cookie.delete('p-totalMoney');
        this.$cookie.set('p-totalMoney', totalMoney, {expires: '1h'});
        let redirect_url = window.location.origin + '/promotion/order-finish?orderNo=' + orderNo + '&us=' + userId + '&ac=' + encodeURIComponent(accessToken)+ '&tmy=' + totalMoney + '&ins=' + insId + '&pid=' + pageId + '&srt=h5wechatpay&mwebUrl=' + mwebUrl;
        let url = mwebUrl + '&redirect_url=' + encodeURIComponent(redirect_url);
        window.location.replace(url);
      } else {
        this.showToast(response.msg);
      }
    },
    async payResult() {
      this.h5WechatPayMiddle = false;
      let self = this;
      self.showLoading();
      let query = self.$route.query;
      let params = {
        "userId": self.$cookie.get('p-userId') || query.us, 
        "accessToken":self.$cookie.get('p-accessToken') || query.ac,
        "sceneCode":'2', 
        "orderNo":query.orderNo,
        "insId":self.$cookie.get('p-insId') || query.ins, 
        "pageId":self.$cookie.get('p-pageId') || query.pid
      };  
      const response = await axios.post(API_UPDATE_PAYMENTSTATUS, params);
      self.hideLoading();
      if(response.code === 1){
        self.pageStatus = 1;
        self.returnMas=response.data;
        let channelPageActivityInfo=response.data.channelPageActivityInfo;
        for(let i=0;i<channelPageActivityInfo.length;i++){
          let cur = channelPageActivityInfo[i];
          if(cur.operationType==2){
            self.banner1 = cur
          }else if(cur.operationType==3){
            self.banner2 = cur
          }
        }
      }else{
        self.pageStatus = 2;
      }
    }
  },
  mounted() {
    let self = this;
    let origin = window.location.origin;
    let shareConfig = {
      //分享标题
      title:"i康保·百万医疗（慢病版）",
      //分享图片地址
      imgUrl:origin+'/share/statics/images/product/101.png',
      //分享链接地址
      linkUrl:this.$cookie.get('p-share-link'),
      //分享描述文案
      description:"最高报销400万各类医疗费 指定慢病既往症也能保 保费最高优惠30%"
    }
    PinganHealth.wxShare(shareConfig);
  },
  created() {
    let query = this.$route.query;
    if (query.srt && query.srt === 'h5wechatpay') {
      this.queryPayInfoWX('init');
    } else {
      this.h5WechatPayMiddle = false;
      this.payResult();
    }
  }
}
</script>

<style scoped lang="stylus">
  .order_finish
    height: 100%
    width: 100%;
  .h5-wechat-result
    height: 100%;
    padding-top: 1.55rem;
    background-color: #fff;
    .name
      text-align: center;
      font-size: .3rem;
      color: #666;
      height: .42rem;
      line-height: .42rem;
    .has-finish-btn
      width: 6.9rem;
      height: .88rem;
      margin: 0 auto;
      margin-top: .54rem
      background:linear-gradient(270deg,rgba(254,146,25,1) 0%,rgba(240,77,22,1) 100%);
      border-radius: .44rem
      font-size: .3rem;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    .repay-btn
      width: 6.9rem;
      height: .88rem;
      margin: 0 auto;
      margin-top: .3rem
      background: #fff;
      border: 1px solid #FF6600;
      border-radius: .44rem
      font-size: .3rem;
      color: #FF6600;
      display: flex;
      align-items: center;
      justify-content: center;
  .page-status-1
    .pay_result
      background: linear-gradient(#FF6F06, #FF890E)
      background: -webkit-linear-gradient(#FF6F06, #FF890E)
      height: 2.5rem
      width:100%
      text-align: center
      padding-top: 0.71rem;
      div
        display: inline-block
      .pay_pic
        vertical-align: middle;
        img
          height:.6rem
          vertical-align: middle;
        p
          color: #fff
          font-size: .4rem
          display: inline-block
          margin-left: .22rem
          vertical-align: middle
          font-weight: 500
    .color_line
      background: #DF7300
      height: .17rem
      margin: -0.61rem auto 0
      width: 7.14rem
      border-radius: .17rem
    .mass_tip
        margin: -.08rem .3rem 0
        box-shadow: 0.04rem 0.04rem 0.16rem 0 rgba(0,0,0,0.08);
        border-radius: 0 0 .1rem .1rem
        background: #fff;
        text-align: left
        vertical-align: middle
        padding-bottom: .08rem;
        .gradient_line
          background: linear-gradient(#FFDFC8, #FFFFFF)
          background: -webkit-linear-gradient(#FFDFC8, #FFFFFF)
          height: 0.3rem;
        .mass_box
          padding 0 .3rem .27rem
          h3
            font-size: .3rem
            color: #333
            margin-bottom: .15rem      
          dl 
            position: relative;
            font-size: .26rem
            height: .37rem
            dt 
              position: absolute
              left: 0px
              top: 0
              color: #333333
            dd 
              text-align: left
              padding-left: 1.3rem
              overflow: hidden
              white-space: nowrap
              text-overflow: ellipsis
          dl+dl
            margin-top:.15rem
    .download_banner
        width: auto;
        margin: 0 .3rem 
        margin-bottom: .22rem
        border-radius:.1rem
        display:block
        img
          width:100%
          border-radius: 0.1rem
    .ad_banner
        margin: .3rem .3rem 0
        width:6.9rem
        border-radius:.1rem
        display:block
        img
          width:100%
          border-radius: 0.1rem
    .download_btn
        display:block
        height:.88rem
        margin:.41rem .3rem
        border-radius: .88rem
        text-align: center
        color:#fff
        font-size:.3rem
        background: -webkit-linear-gradient(left, #F04D16 , #FE9219)
        background: -o-linear-gradient(right, #F04D16, #FE9219)
        background: -moz-linear-gradient(right, #F04D16, #FE9219) /* Firefox 3.6 - 15 */
        background: linear-gradient(to right,#F04D16, #FE9219)
        line-height: .88rem
  .page-status-2
    padding-top: 2.35rem;
    .icon
      width: 1.6rem;
      height: 1.6rem;
      margin: 0 auto;
      img
        display: block
        width: 100%
        height: 100%
    .name
      text-align: center
      height: .48rem
      line-height: .48rem
      margin-top: .44rem
      font-size: .34rem
      color: #333
      margin-bottom: .07rem
    .desc
      font-size: .28rem
      color: #999;
      line-height: .42rem
      text-align: center
    .download-btn
      width: 2.82rem
      height: .8rem
      margin: .44rem auto
      border: 1px solid #FFB574
      border-radius: .4rem
      display: flex
      align-items: center
      justify-content: center
      font-size: .28rem
      color: #FF6600
      font-weight: 500
</style>
